import { env } from '../env';

let host = 'frog.wix.com';

export function setHost(_host) {
  host = _host;
}

export function getHost() {
  return host;
}

export function isWebWorker() {
  /* global WorkerGlobalScope */

  //At the moment, this is the most reliable way of detecting if current code is run in a worker
  //Taken from here: https://stackoverflow.com/a/18002694
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope
  );
}

export function hasSendBeacon() {
  return typeof navigator !== 'undefined' && navigator && navigator.sendBeacon;
}

export function hasFetch() {
  return !!self.fetch;
}

/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
export function provideBrowsingContext(cb) {
  if (typeof env() !== 'undefined' && env()) {
    try {
      return env().top === env().self ? (cb ? cb(env()) : env()) : null;
    } catch (e) {
      return null;
    }
  }

  return null;
}
